import React from 'react';
import { formatType } from '../../utils/shelfIndexUtils';
import { renderSkuWithSoftBreaks } from '../../utils/skuSoftBreak';
import ProductImage from './ProductImage';
import './LabelDetailsPanel.css';

export interface ShelfIndexHistoryRow {
  readonly shelf_index: string | null;
  readonly created_at: string;
}

export interface LabelDetailsPanelProps {
  readonly storageIdPrefix: string;
  readonly createdAtDisplay?: string;
  readonly checkedIn: boolean;
  readonly sku: string;
  readonly shelfIndex?: string | null;
  readonly type?: string | null;
  readonly onSkuClick?: (sku: string) => void;
  readonly onShelfClick?: (shelfIndex: string) => void;
}

export function formatHistoryDate(isoString: string | undefined | null): string {
  if (!isoString) return '—';
  try {
    const d = new Date(isoString);
    return d.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return isoString;
  }
}

function LabelDetailsPanel({
  storageIdPrefix,
  createdAtDisplay,
  checkedIn,
  sku,
  shelfIndex,
  type,
  onSkuClick,
  onShelfClick,
}: LabelDetailsPanelProps): React.ReactElement {
  const shelfDisplay = shelfIndex?.trim() ? shelfIndex : '—';
  const typeDisplay = type ? formatType(type) : '—';

  return (
    <div className="ldp">
      <div className="ldp-tags">
        <span className="pbl-info-tag pbl-storage-id-tag">{storageIdPrefix}</span>
        <span
          className={`pbl-info-tag ${checkedIn ? 'pbl-checked-in-tag' : 'pbl-checked-out-tag'}`}
        >
          {checkedIn ? 'Checked In' : 'Checked Out'}
        </span>
        {createdAtDisplay ? (
          <span className="pbl-info-tag pbl-created-at-tag">{createdAtDisplay}</span>
        ) : null}
      </div>
      <div className="ldp-body">
        <div className="ldp-thumb">
          <ProductImage sku={sku} alt={sku} />
        </div>
        <dl className="ldp-list">
          <dt>SKU:</dt>
          <dd>
            {onSkuClick ? (
              <button
                type="button"
                className="ldp-value ldp-sku sw-sku-clickable"
                onClick={() => onSkuClick(sku)}
              >
                {renderSkuWithSoftBreaks(sku)}
              </button>
            ) : (
              <span className="ldp-value ldp-sku">{renderSkuWithSoftBreaks(sku)}</span>
            )}
          </dd>
          <dt>Shelf:</dt>
          <dd>
            {onShelfClick && shelfIndex?.trim() ? (
              <button
                type="button"
                className="ldp-value sw-shelf-clickable"
                onClick={() => onShelfClick(shelfIndex)}
              >
                {shelfDisplay}
              </button>
            ) : (
              <span className="ldp-value">{shelfDisplay}</span>
            )}
          </dd>
          <dt>Type:</dt>
          <dd>
            <span className="ldp-value">{typeDisplay}</span>
          </dd>
        </dl>
      </div>
    </div>
  );
}

export default LabelDetailsPanel;
